import { createFileRoute } from '@tanstack/react-router'
import StudentDetail from '@/features/students/details'

export const Route = createFileRoute('/_authenticated/users/$studentId')({
  component: StudentDetail,
})
